/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StkRcptSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkRcptSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const stkRcptSync01FetchStkRcptSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkRcptSync01FetchStkRcptSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkRcptSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkRcptSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkRcptSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const stkRcptSync01SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const stkRcptSync01SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkRcptSync01Types.STK_RCPT_SYNC01_RESET_TIMESTAMP]: stkRcptSync01ResetTimestamp,
  [StkRcptSync01Types.STK_RCPT_SYNC01_FETCH_STK_RCPT_SYNC01_LOADING]: stkRcptSync01FetchStkRcptSync01Loading,
  [StkRcptSync01Types.STK_RCPT_SYNC01_FETCH_STK_RCPT_SYNC01_SUCCESS]: stkRcptSync01FetchStkRcptSync01Success,
  [StkRcptSync01Types.STK_RCPT_SYNC01_ADD_SELECTED_DOCUMENTS]: stkRcptSync01AddSelectedDocuments,
  [StkRcptSync01Types.STK_RCPT_SYNC01_REMOVE_SELECTED_DOCUMENTS]: stkRcptSync01RemoveSelectedDocuments,
  [StkRcptSync01Types.STK_RCPT_SYNC01_SET_WORKSPACE_VISIBLE]: stkRcptSync01SetWorkspaceVisible,
  [StkRcptSync01Types.STK_RCPT_SYNC01_SYNC_LOADING]: stkRcptSync01SyncLoading,
  [StkRcptSync01Types.STK_RCPT_SYNC01_SYNC_NOW_SUCCESS]: stkRcptSync01SyncNowSuccess
});
